import styled from 'styled-components';
import { s } from './VIPReport.style';

const ExpectedBid = () => {
  return (
    <s.Div>
      <s.Title>📈예상 입찰가 분석</s.Title>
      <s.TopDescription>
        과거 유사 물건 분석 결과,
        <br />1 회차에는 감정가 대비 낙찰가율,
        <br />2 회차 부터는 최저입찰가 대비 낙찰가율을 추천함.
      </s.TopDescription>
      <s.Table style={{ border: 'none' }}>
        <TableHeader>
          <Header>예상입찰가</Header>
          <Header style={{ width: 'calc(100% - 138px)' }}>수치</Header>
        </TableHeader>
        <Row>
          <RowLeft>
            <Price>금액</Price>
            <Description>감정가 대비 낙찰가율</Description>
          </RowLeft>
          <RowRight>그래프</RowRight>
        </Row>
        <Row>
          <RowLeft>
            <Price>금액</Price>
            <Description>최저입찰가 대비 낙찰가율</Description>
          </RowLeft>
          <RowRight>그래프</RowRight>
        </Row>
        <Row>
          <RowLeft>
            <Price>금액</Price>
            <Description>시세 대비 낙찰가율</Description>
          </RowLeft>
          <RowRight>그래프</RowRight>
        </Row>
      </s.Table>
    </s.Div>
  );
};

export default ExpectedBid;

const TableHeader = styled.div`
  width: 100%;
  border-bottom: 1px solid #e5e8ea;
  display: flex;
  flex-direction: row;
`;

const Header = styled.div`
  width: 138px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
  padding-bottom: 10px;
`;

const Row = styled.div`
  width: 100%;
  height: 72px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
`;

const RowLeft = styled.div`
  width: 260px;
  height: 83px
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Price = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: rgba(55, 56, 60, 0.61);
`;

const Description = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #616161;
`;

const RowRight = styled.div`
  width: calc(100% - 260px);
  height: 83px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
